module.exports = __webpack_public_path__ + "img/logo-adjust.cd3e6dba.png";